import React from 'react';
import { Link } from 'react-router-dom';
import { useProducts, Product } from '../../hooks/useProducts';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EastIcon from '@mui/icons-material/East';
import ProductCard from '../../components/ProductCard';

const HomeFeaturedProducts: React.FC = () => {
  const { products, loading, error } = useProducts();
  const featuredProducts = products.slice(0, 6);

  return (
    <section className="py-12 sm:py-20 bg-white overflow-hidden">
      <div className="container-main">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 sm:mb-12">
          <div className="min-w-0">
            <span className="section-label">Featured Products</span>
            <h2 className="section-heading mt-2">Medical Products &amp; Equipment</h2>
          </div>
          <Link to="/shop" className="text-primary font-semibold text-sm hover:underline flex items-center gap-1 w-fit">
            View All <ArrowForwardIcon fontSize="small" />
          </Link>
        </div>
        {loading && (
          <div className="flex flex-col justify-center items-center py-10 gap-4">
            <CircularProgress size={40} thickness={4} sx={{ color: '#013e8a' }} />
            <p className="text-gray-500 font-semibold animate-pulse">Loading live featured products...</p>
          </div>
        )}
        {error && (
          <div className="text-center py-10 bg-red-50 rounded-3xl border border-red-100">
            <p className="text-red-600 font-semibold text-lg">Failed to load featured products</p>
          </div>
        )}
        {!loading && !error && (
          <div className="flex items-stretch gap-4 sm:gap-6 lg:gap-8 overflow-x-auto pb-8 sm:pb-10 snap-x snap-mandatory hide-scrollbar scroll-pl-4 sm:scroll-pl-0">
            <div className="min-w-[260px] w-[260px] sm:min-w-[280px] sm:w-[280px] md:min-w-[340px] md:w-[340px] flex-shrink-0 min-h-[380px] sm:min-h-[400px] bg-[#E8F0F8] rounded-2xl sm:rounded-[2rem] p-6 sm:p-8 md:p-10 flex flex-col justify-between snap-start">
              <h3 className="text-xl sm:text-2xl md:text-3xl text-primary font-medium leading-tight tracking-tight">
                High-grade medical supplies and equipment for hospitals and laboratories.
              </h3>
              <Link to="/shop" className="mt-8 sm:mt-12 inline-flex items-center gap-2 text-primary font-bold text-sm border border-primary/20 rounded-full px-6 py-3 hover:bg-primary/10 transition-colors w-fit min-h-[44px]">
                shop all products <EastIcon fontSize="small" />
              </Link>
            </div>

            {featuredProducts.map((prod: Product, idx: number) => (
              <ProductCard
                key={prod.id}
                product={prod}
                showBestSeller={idx === 0}
                className="min-w-[240px] w-[240px] sm:min-w-[260px] sm:w-[260px] md:min-w-[300px] md:w-[300px] min-h-[380px] sm:min-h-[400px] snap-start"
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default HomeFeaturedProducts;
